class Modal {
  constructor() {
    this.triggers = document.querySelectorAll('[data-modal-trigger]');
    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const modalId = trigger.getAttribute('data-modal-trigger');
        const modal = document.querySelector(`[data-modal="${modalId}"]`);
        if (modal) this.openModal(modal);
      });
    });

    document.querySelectorAll('[data-modal-close]').forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        const modal = e.target.closest('[data-modal]');
        this.closeModal(modal);
      });
    });

    document.querySelectorAll('[data-modal-overlay]').forEach((overlay) => {
      overlay.addEventListener('click', (e) => {
        const modal = e.target.closest('[data-modal]');
        this.closeModal(modal);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('[data-modal].is-active');
        if (activeModal) this.closeModal(activeModal);
      }
    });
  }

  openModal(modal) {
    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    const focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusableElements.length) focusableElements[0].focus();
  }

  closeModal(modal) {
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new Modal();
});
